import { TypeCompiler } from '@sinclair/typebox/compiler';

import { DaysOfWeekSchedule } from '../schema/days-of-week-schedule.schema';

export const DaysOfWeekScheduleValidator =
  TypeCompiler.Compile(DaysOfWeekSchedule);
